import React from "react";
import loader from "../assets/loader-imagine.gif";

// import { CircleLoader } from "react-awesome-loaders";
// export const CircleLoaderComponent = () => {
//     return (
//         <>
//             <CircleLoader
//                 meshColor={"#6366F1"}
//                 lightColor={"#E0E7FF"}
//                 duration={1.5}
//                 desktopSize={"90px"}
//                 mobileSize={"64px"}
//             />
//         </>
//     );
// };

export const Loader = () => {
  return (
    <div className="grid place-items-center">
      <img src={loader} alt="loading" className="h-[60%]" />;
    </div>
  );
};
